import { ActionType, getType } from 'typesafe-actions'
import { IEntityHashMap } from 'flux-entities'

import * as actions from './actions'
import { ISubscriptionsState, createInitialSubscriptionsState } from './types'
import { ISubscription } from '../../types/subscription'

type TAction = ActionType<typeof actions>

const initialSubscriptionsState = createInitialSubscriptionsState()

const subscriptionsReducer = (state = initialSubscriptionsState, action: TAction): ISubscriptionsState => {
  switch (action.type) {
    case getType(actions.subscriptionsError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.subscriptionsRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.subscriptionsSuccess): {
      const all: IEntityHashMap<ISubscription[]> = {}
      const ids: number[] = []

      // we aren't using ids key for this store
      return {
        all: {
          ...all,
          ...action.payload
        },
        ids,
        touched: true,
        loading: false,
        errors: [],
      }
    }
  }

  return state
}

export {
  subscriptionsReducer,
  initialSubscriptionsState
}
